import type { RouteRecordRaw } from 'vue-router'

export const guestPublicRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/modules/guest/layouts/PublicMain.vue'),
    meta: { public: true },
    children: [
      { path: '', redirect: '/guest-events', meta: { public: true } },
      {
        path: 'guest-events/:eventId',
        name: 'guest-events', // nome público mantido
        component: () => import('@/modules/guest/views/LandingPagePublic.vue'),
        meta: { public: true },
      },
      {
        path: 'event/:eventId',
        name: 'guest-eventsLp',
        component: () => import('@/modules/guest/views/LandingPagePrivate.vue'),
        meta: { public: false },
      },
      {
        path: 'guest-events/denied-invite/:inviteKey',
        name: 'denied-invite',
        component: () =>
          import('@/modules/guest/registration/views/DeniedInvite.vue'),
        props: true,
        meta: { public: true, denied: true },
      },
      {
        path: ':pathMatch(.*)*',
        redirect: '/guest-events',
        meta: { public: true },
      },
      {
        path: '/events/public-registration/:eventId',
        name: 'public-invite',
        component: () =>
          import('@/modules/guest/registration/views/PublicInvite.vue'),
        props: true,
        meta: { public: true }, // <-- ESSENCIAL
      },
      {
        path: 'notifications',
        name: 'guest-notifications',
        component: () => import('@/modules/guest/notifications/views/List.vue'),
        meta: { public: false },
      },
    ],
  },
]
